import React from "react";
import { connect } from "react-redux";
import { guardarRedesSociales } from "./datos.act";
import firebase from "firebase";

const mapState = (state) => {
	return {
		facebook: state.miPerfil.facebook,
		twitter: state.miPerfil.twitter,
		google: state.miPerfil.google,
		instagram: state.miPerfil.instagram,
		loadRedesSociales: state.miPerfil.loadRedesSociales
	};
};

const mapDispatch = (dispatch) => {
	return {
		setRedes: (obj) => {
			dispatch({ "type": "MI_PERFIL_SET_REDES", "facebook": obj.facebook, "twitter": obj.twitter, "google": obj.google, "instagram": obj.instagram });
		},
		setRedesFlag: (flag) => {
			dispatch({ "type": "MI_PERFIL_SET_REDES_FLAG", "flag": flag });
		},
		guardarRedesSociales: (datos) => {
			dispatch(guardarRedesSociales(datos));
		},
		addEvento: (evento) => {
			dispatch({ "type": "MI_PERFIL_SET_EVENT", "evento": evento});
		}
	};
};

class ModalRedesSociales extends React.Component {

	state = {
		facebook: this.props.facebook,
		twitter: this.props.twitter,
		google: this.props.google,
		instagram: this.props.instagram
	}
	cancelar = () => {
		this.refs.facebook.value = this.props.facebook.length > 0 ? this.props.facebook : "";
		this.refs.twitter.value = this.props.twitter.length > 0 ? this.props.twitter : "";
		this.refs.google.value = this.props.google.length > 0 ? this.props.google : "";
		this.refs.instagram.value = this.props.instagram.length > 0 ? this.props.instagram : "";
		$("#modal-redes-sociales").modal("toggle");
		this.props.addEvento("Cancelar-RedesSociales");
	}
	ok = () => {
		let obj = {
			facebook: this.refs.facebook.value.trim(),
			twitter: this.refs.twitter.value.trim(),
			google: this.refs.google.value.trim(),
			instagram: this.refs.instagram.value.trim()
		};
		if(obj.facebook.length > 0  || obj.twitter.length > 0 || obj.google.length > 0 || obj.instagram.length > 0) {
			this.props.setRedesFlag(true);
		} else {
			this.props.setRedesFlag(false);
		}
		this.refs.facebook.value = obj.facebook;
		this.refs.twitter.value = obj.twitter;
		this.refs.google.value = obj.google;
		this.refs.instagram.value = obj.instagram;
		this.props.guardarRedesSociales(obj);
		$("#modal-redes-sociales").modal("toggle");
		this.props.addEvento("Guardar-RedesSociales");
	}

	render() {
		return <div>
			<h5>
				<i>
					<img src={ require("../img/icon-share.png") } />
				</i>Editar redes sociales
			</h5>
			<div className="texto-17 mt-34">
				<p>Modifica tus redes sociales.</p>
			</div>
			<div className="row redes">
				<div className="col-xs-12 mt-34 col-md-10 col-md-offset-1">
					{ this.props.loadRedesSociales &&
					<div className="row bordered">
						<div className="col-xs-12 col-md-6">
							<p>
								<i><img src={ require("../img/facebook.png") } /></i>
								<input defaultValue={this.props.facebook} ref="facebook" type="text" placeholder="nombre_Usuario" />
							</p>
						</div>
						<div className="col-xs-12 col-md-6">
							<p>
								<i><img src={ require("../img/twitter.png") } /></i>
								<input defaultValue={this.props.twitter} ref="twitter" type="text" placeholder="nombre_Usuario" />
							</p>
						</div>
						<div className="col-xs-12 col-md-6">
							<p>
								<i><img src={ require("../img/icon_google.png") } /></i>
								<input defaultValue={this.props.google} ref="google" type="text" placeholder="nombre_Usuario" />
							</p>
						</div>
						<div className="col-xs-12 col-md-6">
							<p>
								<i><img src={ require("../img/icon_instagram.png") } /></i>
								<input defaultValue={this.props.instagram} ref="instagram" type="text" placeholder="nombre_Usuario" />
							</p>
						</div>
					</div>
					}
				</div>
				<div className="col-xs-12">
					<div className="text-center aceptar-cancelar-btn">
						<a onClick={this.cancelar}>Cancelar</a>
						<a onClick={this.ok} className="orange-btn">Guardar</a>
					</div>
				</div>
			</div>
		</div>;
	}
}

export default connect(mapState, mapDispatch)(ModalRedesSociales);



// WEBPACK FOOTER //
// ./src/miPerfil/modalRedesSociales.cmpt.js